webpackJsonp([242426341129745],{

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Drafts'
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'ol',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Can be toggled on/off in the account workspace page. '
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Adding and editing creates a draft, instead of saving to the orginal.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Drafts can be saved or discarded at will.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Drafts can be played back just as any other saved test.    '
	              )
	            ),
	            _react2.default.createElement(
	              'h1',
	              null,
	              'Turning on Drafts'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Navigate to the account workspace where you\'d like to toggle drafts.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1530673930/Drafts/Screen_Shot_2018-07-03_at_10.10.52_PM.png', style: { width: "400px" } })
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Now when you create/edit a test it will copy that test as a draft.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'If editing a test, the original won\'t be touched until you hit "save draft" which will replace the existing one. '
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1530673941/Drafts/Screen_Shot_2018-07-03_at_10.05.44_PM.png', style: { width: "400px" } })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'info' },
	              'Draft playback is seamless.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1530674220/Drafts/draft-playback.gif', style: { width: "400px" } })
	            ),
	            _react2.default.createElement('p', null)
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-drafts-js-43ba4d49dda030e89216.js